import { render, staticRenderFns } from "./TransferGraduationSendDocumentForm.vue?vue&type=template&id=622334e8&scoped=true&"
import script from "./TransferGraduationSendDocumentForm.vue?vue&type=script&lang=ts&"
export * from "./TransferGraduationSendDocumentForm.vue?vue&type=script&lang=ts&"
import style0 from "./TransferGraduationSendDocumentForm.vue?vue&type=style&index=0&id=622334e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622334e8",
  null
  
)

export default component.exports